module.exports = __webpack_public_path__ + "img/dashboard-users-female.171cb905.png";